import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, LoadingContent, Select } from '../../../components'
import { history } from '../../../helpers'
import PdcaLayout from '../base/pdcaLayout'
import { gravarEmpresaPdca, listarEmpresasProjetoPdca, setSetupEmpresaSelecionada } from './redux/setupActions'
import './setup.scss'

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { grupos, grupo, filters, empresa, categoria, sistema } = useSelector(state => state.layoutState)
  const { empresas, empresaSelecionada, carregandoLista, carregandoGravacao } = useSelector(state => state.pdcaState.pdcaSetupState)
  const { projetoNome } = useSelector(state => state.pdcaState.pdcaBaseState)

  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

  useEffect(() => {
    if (idProjetos) {
      dispatch(listarEmpresasProjetoPdca(idProjetos, nlsPopup))
    }
  }, [dispatch, idProjetos, sistema.idioma])

  const handleSelecionarEmpresa = e => {
    dispatch(setSetupEmpresaSelecionada(e?.value || ''))
  }

  const handleConfirmar = () => {
    dispatch(gravarEmpresaPdca(empresaSelecionada, idProjetos, nlsPopup))
  }

  const handleCancelar = () => {
    history.push(`/myprojects`)
  }

  const semEmpresas = !carregandoLista && empresas.length === 0
  const carregandoTela = carregandoLista || carregandoGravacao
  const nomeProjetoExibir = projetoNome || ''

  return (
    <PdcaLayout>
      <div className='box-pdca-setup'>
        <div className='box-pdca-setup-wrap'>
          <div className='box-pdca-setup-header'>
            <h2>{nls.title}</h2>
            <div className='box-pdca-setup-project'>
              {nls.projectLabel} {nomeProjetoExibir}
            </div>
          </div>

          <LoadingContent
            show={carregandoTela}
            title={nls.loading}
            height='260px'
          >
            <div className='box-pdca-setup-card'>
              <div className='box-pdca-setup-texts'>
                <p>{nls.descriptionLine1}</p>
                <p>{nls.descriptionLine2}</p>
              </div>

              <div className='box-pdca-setup-form-group'>
                <div className='box-pdca-setup-field'>
                  {semEmpresas ? (
                    <div className='box-pdca-setup-empty'>
                      <strong>{nls.emptyTitle}</strong>
                      <p>{nls.emptyDescription}</p>
                    </div>
                  ) : (
                    <Select
                      name='empresaPdca'
                      label={nls.selectLabel}
                      options={empresas}
                      selected={empresaSelecionada || ''}
                      action={e => handleSelecionarEmpresa(e)}
                      selectedItem={false}
                      optionLabel='empresadescricao'
                      optionValue='empresaid'
                    />
                  )}
                </div>
              </div>

              <div className='box-pdca-setup-warning'>
                {nls.warningText}
              </div>

              <div className='box-pdca-setup-actions'>
                <Button
                  color='primary'
                  onClick={() => handleConfirmar()}
                  disabled={!empresaSelecionada?.empresaid || semEmpresas || carregandoTela}
                >
                  {nls.confirmButton}
                </Button>

                <Button
                  type='link'
                  onClick={() => handleCancelar()}
                >
                  {nls.cancelButton}
                </Button>
              </div>
            </div>
          </LoadingContent>
        </div>
      </div>
    </PdcaLayout>
  )
}